import MainLayout from './MainLayout.component'

export default MainLayout
